import { SIGN_OUT } from 'Global/Stores/auth'

const STATISTICS_GET = 'API|STATISTICS/GET'
const STATISTICS_GET_FULFILLED = `FULFILLED_${STATISTICS_GET}`
const STATISTICS_GET_PENDING = `PENDING_${STATISTICS_GET}`
const STATISTICS_GET_REJECTED = `REJECTED_${STATISTICS_GET}`

/**
 * Get request to API to get statistics.
 * @returns {Object} Action Object
 */
export const getStatistics = () => ({
  meta: { url: '/api/v1/statistics' },
  type: STATISTICS_GET,
})

const initialState = {
  data: {},
  error: false,
  pending: false,
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
    case STATISTICS_GET_FULFILLED:
      return {
        ...state,
        data: payload.data,
        error: false,
        pending: false,
      }

    case STATISTICS_GET_PENDING:
      return {
        ...state,
        error: false,
        pending: true,
      }

    case STATISTICS_GET_REJECTED:
      return {
        ...state,
        error: true,
        pending: false,
      }

    case SIGN_OUT:
      return initialState

    default:
      return state
  }
}

export default reducer
